import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {ToastModule} from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';



/**
 * rutas
 */
import { AppRoutingModule } from 'src/app/app.routes';
/**
 * Servicios
 */
import { ProductsService } from './services/producto/products.service';
import {MessageService} from 'primeng/api'

 /**
  * Componentes
  */
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { FormulariosComponent } from './components/formularios/formularios.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ProductsComponent } from './components/products/products.component';
import { EditProductComponent } from './components/edit-product/edit-product.component';
import { MenuComponent } from './components/menu/menu.component';
import { CategoriaProductsComponent } from './modules/productos/categoria-productos/categoria-productos.component';


import { SidebarComponent } from './components/sidebar/sidebar.component';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidenavCellComponent } from './components/dashboard/sidenav-cell/sidenav-cell.component';

/* de tiritas.module */
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/components/slider/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ConfirmationService} from 'primeng/api';
import { utensiliosComponent } from './modules/utensilios/categoria-utensilios/utensilios.component';
import { CategoriaParametrosComponent } from './modules/parametros/categoria-parametros/categoria-parametros.component';

import { ControlCristalModule } from './modules/control/app.control.modules';
import { CategoriaControlComponent } from './modules/control/categoria-control/categoria.component';
import { tiritasComponent } from './modules/tiritas/categoria-tiritas/tiritas.component';
import { AnexoComponent } from './components/anexo/anexo.component';
import { PesosCreateComponent } from './modules/pesos/create/pesos.component';
import { PesosComponent } from './modules/pesos/pesos.component';
import { ListPesosComponent } from './modules/pesos/list/list-pesos/list-pesos.component';
import { UpdatePesosComponent } from './modules/pesos/update/updatePesos.component';
import { ImprimirSharedModule } from './components/imprimir/imprimir.module.share';

import { ImprimirPesosSharedModule } from './components/imprimirPesos/imprimir-pesos.module.share';
import { ZumosCategoriaComponent } from './modules/zumos/zumos-categoria/zumos-categoria.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { EtiquetaCategoriaComponent } from './modules/etiquetas/etiquetas-categoria/etiquetas-categoria.component';
import { UsuarioCategoriaComponent } from './modules/usuarios/usuarios-categoria/usuarios-categoria.component';
import { VariedadesCategoriaComponent } from './modules/variedades/variedades-categoria/variedades-categoria.component';
import { PipeModule } from './pipes/pipe.module';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { CategoriaTestVidaComponent } from './modules/test-de-vida/categoria-test-de-vida/categoria-test-de-vida.component';
import { CategoriaConformidadComponent } from './modules/conformidad/categoria-conformidad/categoria-conformidad.component';
import { CategoriaTransporteComponent } from './modules/transporte/categoria-transporte/categoria-transporte.component';
import { ImprimirPesosPitufoMultipleSharedModule } from './components/imprimir-multilples/imprimir-pesos-pitufo/imprimir-pesos-pitufo-multiple.module.share';
import { PaisesCategoriaComponent } from './modules/paises/paises_categoria/paises-categoria.component';
import { CategoriaTransporteRutasComponent } from './modules/transporte-rutas/categoria-transporte/categoria-transporte.component';
import { CheckboxModule } from 'primeng/checkbox';
import {AccordionModule} from 'primeng/accordion';
import { BotonesActionModule } from './components/botones/botones.module';
import { SimpleTableModule } from './components/table/simple-table/simple-table.modules';

import {SlideMenuModule} from 'primeng/slidemenu';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    FormulariosComponent,
    PageNotFoundComponent,
    ProductsComponent,
    EditProductComponent,
    SidebarComponent,
    DashboardComponent,
    LoginComponent,
    DashboardComponent,
    SidenavCellComponent,
    CategoriaProductsComponent,
    utensiliosComponent,
    CategoriaParametrosComponent,
    CategoriaControlComponent,
    tiritasComponent,
    AnexoComponent,
    PesosComponent,
    PesosCreateComponent,
    ListPesosComponent,
    UpdatePesosComponent,
    PesosComponent,
    ZumosCategoriaComponent,
    EtiquetaCategoriaComponent,
    UsuarioCategoriaComponent,
    VariedadesCategoriaComponent,
    DocumentosComponent,
    CategoriaTestVidaComponent,
    CategoriaConformidadComponent,
    CategoriaTransporteComponent,
    PaisesCategoriaComponent,
    CategoriaTransporteRutasComponent,
    //ReplaceSemicolonPipe
   
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ImprimirPesosSharedModule,
    TieredMenuModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastModule,
    MessagesModule,
    TableModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    SliderModule,
    CalendarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule,
    ControlCristalModule,
    FormsModule,
    ImprimirSharedModule,
    PipeModule,
    CheckboxModule,
    AccordionModule,
    ImprimirPesosPitufoMultipleSharedModule,
    SimpleTableModule,
    BotonesActionModule,
    SlideMenuModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  
  ],
  providers: [
    ProductsService,
    MessageService,
    ConfirmationService
  ],
  bootstrap: [AppComponent],
  exports:[
    CategoriaTestVidaComponent,
  ]
})
export class AppModule { }
